import { render, staticRenderFns } from "./businessTable.vue?vue&type=template&id=24ac57b2&scoped=true"
import script from "./businessTable.vue?vue&type=script&lang=js"
export * from "./businessTable.vue?vue&type=script&lang=js"
import style0 from "./businessTable.vue?vue&type=style&index=0&id=24ac57b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ac57b2",
  null
  
)

export default component.exports